import { useId } from "react";

export function OrbitalArtwork() {
  const id = useId().replace(/:/g, "");
  return (
    <svg
      className="orbital-artwork"
      viewBox="0 0 440 330"
      fill="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient
          id={`${id}-metal`}
          x1="65"
          y1="55"
          x2="355"
          y2="260"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--orbital-dark, #455575)" />
          <stop offset=".24" stopColor="var(--orbital-light, #f0f5ff)" />
          <stop offset=".45" stopColor="var(--orbital-mid, #788aae)" />
          <stop offset=".64" stopColor="var(--orbital-soft, #c7d4f3)" />
          <stop offset=".83" stopColor="var(--orbital-deep, #3c527c)" />
          <stop offset="1" stopColor="var(--orbital-end, #abbddd)" />
        </linearGradient>
        <radialGradient id={`${id}-glow`}>
          <stop stopColor="var(--orbital-glow, #6288ff)" stopOpacity=".36" />
          <stop
            offset="1"
            stopColor="var(--orbital-glow, #6288ff)"
            stopOpacity="0"
          />
        </radialGradient>
        <linearGradient
          id={`${id}-face`}
          x1="160"
          y1="110"
          x2="270"
          y2="235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--orbital-face, #fff)" />
          <stop offset="1" stopColor="var(--orbital-face-end, #768fc8)" />
        </linearGradient>
      </defs>
      <ellipse cx="220" cy="165" rx="204" ry="162" fill={`url(#${id}-glow)`} />
      <g stroke="var(--orbital-mid, #91a5d1)" strokeOpacity=".13">
        <path d="M20 165h400M220 15v300" />
        <circle cx="220" cy="165" r="144" strokeDasharray="2 8" />
        <circle cx="220" cy="165" r="113" strokeDasharray="2 8" />
      </g>
      <g
        className="orbital-sculpture"
        stroke={`url(#${id}-metal)`}
        strokeWidth="11"
      >
        <ellipse
          cx="220"
          cy="165"
          rx="149"
          ry="67"
          transform="rotate(-28 220 165)"
        />
        <ellipse
          cx="220"
          cy="165"
          rx="149"
          ry="67"
          transform="rotate(32 220 165)"
        />
        <ellipse
          cx="220"
          cy="165"
          rx="149"
          ry="67"
          transform="rotate(92 220 165)"
        />
      </g>
      <path
        d="m190 128 30 21 30-21 15 22-25 16 25 17-15 22-30-21-30 21-15-22 25-17-25-16z"
        fill={`url(#${id}-face)`}
      />
      <circle cx="92" cy="202" r="5" fill="var(--orbital-light, #e9f0ff)" />
      <circle cx="337" cy="93" r="4" fill="var(--orbital-end, #89aaff)" />
      <g stroke="var(--orbital-soft, #d2e1ff)" strokeOpacity=".5">
        <path d="M52 61h10m-5-5v10M361 257h10m-5-5v10" />
      </g>
    </svg>
  );
}
